export const EVENT_STATUS = {
  ENQUIRY: "enquiry",
  CONFIRMED: "confirmed",
  SHOOTING: "shooting",
  EDITING: "editing",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const EVENT_PRIORITY = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
};

export const EVENT_TYPES = [
  { value: "wedding", label: "Wedding" },
  { value: "birthday", label: "Birthday" },
  { value: "reception", label: "Reception" },
  { value: "engagement", label: "Engagement" },
  { value: "maternity", label: "Maternity" },
  { value: "corporate", label: "Corporate" },
  { value: "political", label: "Political" },
  { value: "portrait", label: "Portrait" },
  { value: "other", label: "Other" },
];

export const STAFF_ROLES = [
  { value: "photographer", label: "Photographer" },
  { value: "videographer", label: "Videographer" },
  { value: "assistant", label: "Assistant" },
  { value: "drone_operator", label: "Drone Operator" },
  { value: "editor", label: "Editor" },
  { value: "driver", label: "Driver" },
];

export const STAFF_STATUS = {
  ASSIGNED: "assigned",
  CONFIRMED: "confirmed",
  DECLINED: "declined",
  COMPLETED: "completed",
};

export const PAYMENT_STATUS = {
  PENDING: "pending",
  PARTIAL: "partial",
  PAID: "paid",
};

export const EQUIPMENT_CATEGORIES = [
  "Camera",
  "Lens",
  "Drone",
  "Gimbal",
  "Lighting",
  "Audio",
  "Tripod",
  "Accessory",
];

export const WORKFLOW_STEPS = [
  "photoUploaded",
  "cullingCompleted",
  "selectionCompleted",
  "editingCompleted",
  "albumDesigned",
  "albumPrinted",
  "videoEdited",
  "highlightsCompleted",
  "reelsCompleted",
  "delivered",
];

export const STATUS_OPTIONS = Object.values(EVENT_STATUS).map((v) => ({
  value: v,
  label: v.charAt(0).toUpperCase() + v.slice(1),
}));

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch events. Please try again.",
  FETCH_ONE_FAILED: "Failed to fetch event details.",
  CREATE_FAILED: "Failed to create event. Please try again.",
  UPDATE_FAILED: "Failed to update event. Please try again.",
  DELETE_FAILED: "Failed to delete event. Please try again.",
  STAFF_ADD_FAILED: "Failed to assign staff. Please try again.",
  STAFF_CONFLICT: "This staff member is already assigned on this date.",
  EQUIPMENT_ADD_FAILED: "Failed to assign equipment.",
  EQUIPMENT_CONFLICT: "This equipment is already booked on this date.",
  SCHEDULE_ADD_FAILED: "Failed to add schedule day.",
  EXPENSE_ADD_FAILED: "Failed to add expense.",
  NOT_FOUND: "Event not found.",
};

export const SUCCESS_MESSAGES = {
  CREATE_SUCCESS: "Event created successfully!",
  UPDATE_SUCCESS: "Event updated successfully!",
  DELETE_SUCCESS: "Event deleted successfully!",
  STAFF_ASSIGNED: "Staff assigned successfully!",
  EQUIPMENT_ASSIGNED: "Equipment assigned successfully!",
  EXPENSE_ADDED: "Expense recorded successfully!",
};
